import { faTag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { AllDiscountProductApi, getCategoryDiscountApi } from '../../Api/BarestSupplierServices'
import Button from '../../Components/Button/Button'
import MenuTitle from '../../Components/MenuTitlle/MenuTitle'
import { errorToast, succToast } from '../../Utils/Toast/Toast'
import Style from './DiscountOfOneCategory.module.css'
const DiscountOfOneCategory = () => {
    const [percent,setPercent]=useState(true)
    const [data,setData]=useState([])
    const[categoryId,setCategoryId]=useState(1)
    const[deleteCategoryId,setDeleteCategoryId]=useState(1)
    const [inputTomanValue,setInputTomanValue]=useState('')
    const [inputPercentValue,setInputPercentValue]=useState('')

    ///////////هندل کردن درصد و تومان/////////
    const percentHandler =(e)=>{
        if(e==="درصد"){
            setPercent(true)
            setInputPercentValue('')
            setInputTomanValue('')
        }
        else{
            setPercent(false)
            setInputPercentValue('')
            setInputTomanValue('')
        }
    }

    useEffect(()=>{
        getCategory()
    },[])

    ////////گرفتن داده از بک اند
    const getCategory=async()=>{
        const result =await getCategoryDiscountApi()
        setData(result.category)
    }

    ///////ارسال تخفیف به بک اند/////////
    const postAllProduct=()=>{
        const discount={
            id:categoryId,
            product_id:0,
            const:inputTomanValue? parseInt(inputTomanValue):0,
            precentage:inputPercentValue ?parseInt(inputPercentValue) :0
        }
        AllDiscountProductApi(discount,(suc)=>{
            if(suc.status===1){
                succToast("با موفقیت ارسال شد") 
                setInputPercentValue('')
                setInputTomanValue('')
            }
            else{
                errorToast("مشکلی پیش آمده")
                setInputPercentValue('')
                setInputTomanValue('') 
            }
            
        }) 
    }

//////////////////برداشتن تخفیف
    const deleteCategoryDiscount=()=>{
        const Delete={
            id:deleteCategoryId,
            product_id:0,
            const:0,
            precentage:0
        }
        AllDiscountProductApi(Delete,(suc)=>{
            if(suc.status===1){
                succToast("با موفقیت حذف شد ") 
                setInputPercentValue('')
                setInputTomanValue('')
            }
            else{
                errorToast("مشکلی پیش آمده")
                setInputPercentValue('')
                setInputTomanValue('') 
            }
            
        })
    }
    return (
        <div className={Style.pageHolder}>
            <MenuTitle title={"تخفیف یک دسته بندی"}/>
            <div className={Style.centerHolder}>
                <div className={Style.picHolder}>
                    <img src={"/Assets/Images/discountOneCategory/dis.png"} alt=""/>
                </div>
                <section className={Style.discountPart}>
                   <p className={Style.discountTitle}><FontAwesomeIcon className={Style.discountIcon} icon={faTag} />اعمال تخفیف روی بخشی از محصولات:</p>
                    <div className={Style.discountType}>
                        <h3 className={Style.text}>دسته بندی مورد نظر را برای تخفیف مشخص کنید:</h3>
                        <select value={categoryId} onChange={(e)=>setCategoryId(e.target.value)} className={Style.typeHolder} >
                        <option disabled={true} value={1}>انتخاب کنید</option>
                            {
                            data.map(item=>
                            <option key={item.id} value={item.id} className={Style.option}>{item.category}</option>   
                            )}
                        </select>
                    </div>
                    <div className={Style.discountType}>
                        <h3 className={Style.text}>نوع تخفیف خود را مشخص کنید:</h3>
                        <select onChange={(e)=>{percentHandler(e.target.value)}} className={Style.typeHolder}>
                           <option value={"درصد"} className={Style.option}>درصد</option>
                           <option value={"وجه مالی"} className={Style.option}>وجه مالی</option>
                        </select>
                    </div>
                    <div>
                    {
                        percent ?
                        <div className={Style.discountAmountHolder}>
                            <FontAwesomeIcon className={Style.discountIcon} icon={faTag}/>
                            <h3 className={Style.mountTextfirst}>به مقدار</h3>
                            <input value={inputPercentValue} onChange={(e)=>setInputPercentValue(e.target.value)}  className={Style.discountInput}/>
                            <h3 className={Style.mountTextSecond}>درصد تخفیف روی محصولات اعمال شود</h3> 
                        </div>
                        :
                        <div className={Style.discountTomanHolder}>
                            <h3 className={Style.mountTextfirst}><FontAwesomeIcon className={Style.discountIconToman} icon={faTag}/>به مقدار</h3>
                            <input value={inputTomanValue} onChange={(e)=>setInputTomanValue(e.target.value)}  className={Style.discountToman}/>
                            <h3 className={Style.mountTextSecond}>تومان تخفیف روی محصولات اعمال شود</h3> 
                        </div>
                    }
                    </div>
                    <Button ClickHandler={postAllProduct} ClassBtn={"confirmBtn"} Value={"ثبت"}/>
                </section>
                <section className={Style.removeDiscount}>
                    <p className={Style.discountTitle}><FontAwesomeIcon className={Style.discountIcon} icon={faTag} />اعمال تخفیف روی بخشی از محصولات:</p>
                    <div className={Style.discountType}>
                        <h3 className={Style.text}>دسته بندی مورد نظر را برای تخفیف مشخص کنید:</h3>
                        <select value={deleteCategoryId} onChange={(e)=>setDeleteCategoryId(e.target.value)} className={Style.typeHolder}>
                        <option disabled={true} value={1}>انتخاب کنید</option>
                            {
                            data.map(item=>
                            <option key={item.id} value={item.id} className={Style.option}>{item.category}</option>   
                            )}
                        </select>
                    </div>
                    <Button ClickHandler={deleteCategoryDiscount} ClassBtn={"confirmBtn"} Value={"برداشتن تخفیف"}/>
                </section>
            </div>
        </div>
    )
}

export default DiscountOfOneCategory
